<template>
  <!-- 合作 -->
  <div class="warrper">
    <div class="header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/hyhz.png"
        alt=""
      />
    </div>
    <el-backtop></el-backtop>
    <div class="content_ml">
      <span @click="tiaozhuan()">首页></span
      ><span style="color: black">行业合作</span>
    </div>
    <div class="contentA">
      <el-tabs
        style="margin-top: 50px; margin-bottom: 100px"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="合作模式" name="合作模式">
          <div class="xmzl wow fadeInUp" data-wow-duration=".5s">
            <div class="card">
              <div
                class="jtcard"
                @mouseover="changeIndex('1')"
                @mouseout="changeIndexBack('1')"
              >
                <img v-show="!show1" src="../assets/zscq/供应链服务.png" />
                <img v-show="show1" src="../assets/zscq/供应链服务 拷贝.png" />
                <p>产品供应服务</p>
              </div>
              <div
                class="jtcard"
                @mouseover="changeIndex('2')"
                @mouseout="changeIndexBack('2')"
              >
                <img v-show="!show2" src="../assets/zscq/定制游.png" />
                <img v-show="show2" src="../assets/zscq/定制游 拷贝 2.png" />
                <p>定制开发服务</p>
              </div>
              <div
                class="jtcard"
                @mouseover="changeIndex('3')"
                @mouseout="changeIndexBack('3')"
              >
                <img
                  v-show="!show3"
                  src="../assets/zscq/握手,合作,协作 (1).png"
                />
                <img
                  v-show="show3"
                  src="../assets/zscq/握手,合作,协作 (1) 拷贝.png"
                />
                <p>联合研发服务</p>
              </div>
              <div
                class="jtcard"
                @mouseover="changeIndex('4')"
                @mouseout="changeIndexBack('4')"
              >
                <img v-show="!show4" src="../assets/zscq/11中转站-线性.png" />
                <img
                  v-show="show4"
                  src="../assets/zscq/11中转站-线性 拷贝.png"
                />
                <p>成果转化服务</p>
              </div>
            </div>
            <Contact></Contact>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import { selectcol } from "@/api/patient.js";
import PDF from "../components/pdf.vue";
import Contact from "../components/ContactUs.vue";
export default {
  components: { PDF, Contact },
  name: "",
  data() {
    return {
      activeName: "合作模式",
      datatotal: 0,
      xmDatawj: [],
      datatotalwj: 0,
      showPdf: false,
      xmData: [],
      page: 1,
      rows: 100,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
    };
  },
  mounted() {
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  filters: {},
  methods: {
    changeIndex(e) {
      // 鼠标移入事件
      switch (e) {
        case "1":
          this.show1 = true;
          break;
        case "2":
          this.show2 = true;
          break;
        case "3":
          this.show3 = true;
          break;
        case "4":
          this.show4 = true;
          break;
      }
    },
    changeIndexBack(e) {
      // 鼠标移出事件
      switch (e) {
        case "1":
          this.show1 = false;
          break;
        case "2":
          this.show2 = false;
          break;
        case "3":
          this.show3 = false;
          break;
        case "4":
          this.show4 = false;
          break;
      }
    },
    handleClick(tab, event) {
      this.getSelectcoll();
    },
    tiaozhuan() {
      this.$router.push("/");
    },
    //获取项目资料
    async getSelectcoll() {
      let data = new FormData();
      data.append("page", this.page);
      data.append("rows", this.rows);
      data.append("xueyuan", "倒");
      selectcol(data).then((res) => {
        this.xmData = res.rows;
        this.datatotal = res.total;
      });
    },
  },

  watch: {},
};
</script>
<style scoped>
>>> .el-tabs__item {
  font-size: 20px !important;
}
>>> .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #e4e7ed;
  z-index: 1;
}
>>> .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #296cbf;
  z-index: 1;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}
>>> .el-tabs__item {
  line-height: 20px;
  padding-right: 100px;
}
>>> .el-tabs__header {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss" scoped>
.warrper {
  width: 100%;
  .content_ml {
    margin-top: 20px;
    margin-left: 20%;
    color: #d3d3d3;
  }
  .content_ml:hover {
    margin-top: 20px;
    margin-left: 20%;
    color: #d3d3d3;
    pointer-events: auto;
    cursor: pointer;
  }
  .header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/lx/hz.png);
    // background-size: 100%, 100%;
    // background-size: cover;
    // background-repeat: no-repeat;
  }
  .contentA {
    width: 60%;
    margin: auto;

    .xmzl {
      margin: 30px auto;
      width: 1061px;
      background: #ffffff;
      // box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.21);
      .card {
        display: flex;
        justify-content: center;
        align-items: center;

        .jtcard:hover {
          padding-top: 50px;
          text-align: center;
          cursor: pointer;
          width: 200px;
          // height: 424px;
          background: #ffffff;
          margin: 20px;
          border-radius: 10px;

          // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);

          p {
            margin-top: 20px;
            width: 200px;
            height: 61px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #296cbf;
          }
        }

        .jtcard {
          padding-top: 50px;
          text-align: center;
          width: 200px;
          cursor: pointer;
          // height: 424px;
          background: #ffffff;
          margin: 20px;
          border-radius: 10px;

          // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);

          p {
            margin-top: 20px;
            width: 200px;
            height: 61px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
          }
        }
      }
    }
    .wrapp {
      margin: 30px auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      width: 1061px;
      min-height: 529px;
      background: #ffffff;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.21);
      .box {
        margin: 30px;
        width: 195px;
        text-align: center;
        // margin: auto;
        a {
          text-decoration: none;
        }
        .ibox {
          img {
            width: 102px;
            height: 102px;
          }
        }
        h3 {
          height: 44px;
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        h3:hover {
          height: 44px;
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0084ff;
        }
      }
    }
  }
}
</style>
